import { Slate } from 'slate-react';

export default Slate;
